<template>
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header py-0">
      <h6 class="py-3 mb-0">Cursos</h6>
    </div>
    <div class="card-body">
      <h5>Em Andamento</h5>
      <div v-if="courses.inProgress.length > 0" class="row">
        <div
          v-for="course in courses.inProgress"
          :key="course.id"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <CardCourse
            :course="course"
            borderColor="primary"
            :showStatus="false"
            :showProgress="true"
          >
            <router-link
              :to="`/courses/${course.id}`"
              title="Visualizar detalhes do curso"
            >
              <span class="badge bg-primary">Detalhes do Curso</span>
            </router-link>
          </CardCourse>
        </div>
      </div>
      <p v-else>Nenhum curso está em andamento</p>
      <hr />
      <h5>Não Iniciados</h5>
      <div v-if="courses.notStarted.length > 0" class="row">
        <div
          v-for="course in courses.notStarted"
          :key="course.id"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <CardCourse
            :course="course"
            borderColor="secondary"
            :showStatus="false"
            :showProgress="false"
          >
            <router-link
              :to="`/courses/${course.id}`"
              title="Visualizar detalhes do curso"
            >
              <span class="badge bg-primary">Detalhes do Curso</span>
            </router-link>
          </CardCourse>
        </div>
      </div>
      <p v-else>Não existe cursos para serem iniciados</p>
      <hr />
      <h5>Concluídos</h5>
      <div v-if="courses.done.length > 0" class="row">
        <div
          v-for="course in courses.done"
          :key="course.id"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <CardCourse
            :course="course"
            borderColor="success"
            :showStatus="false"
            :showProgress="false"
          >
            <router-link
              :to="`/courses/${course.id}`"
              title="Visualizar detalhes do curso"
            >
              <span class="badge bg-primary">Detalhes do Curso</span>
            </router-link>
            <span
              role="button"
              class="badge bg-secondary ms-2"
              title="Baixar certificado"
              @click="getCertificate(course.key)"
            >
              Certificado
            </span>
          </CardCourse>
        </div>
      </div>
      <p v-else>Não existe cursos concluídos</p>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import CardCourse from '@/components/commons/CardCourse.vue'
import createCertificate from '@/utils/certificate'

export default {
  name: 'CoursesUser',

  components: {
    LoadingData,
    CardCourse,
  },

  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      courses: {},
    }
  },

  methods: {
    async getCoursesUser() {
      try {
        this.courses = await this.$store.dispatch('getCoursesUser', this.userId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCertificate(key) {
      try {
        const dataCertificate = await this.$store.dispatch(
          'getCertificateAuth',
          key,
        )

        createCertificate({
          certificate: dataCertificate,
          type: 'download',
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getCoursesUser()
  },
}
</script>
